export default __webpack_public_path__ + "img/kaombo norte.7743ef1f.jpg";